import { useState, useRef, useEffect } from "react";
import { useDispatch, useStore, useSelector } from "react-redux";
import { addMiddleware, removeMiddleware } from "./middleware-manager.js";
import { selectModuleLoaded, setModuleLoaded, removeModuleLoaded } from "./module-manager.slice.js";
const useModuleManager = (config, disableAutoClear = true) => {
  const [readyToRender, setReadyToRenderState] = useState(false);
  const dispatch = useDispatch();
  const dispatchCalledRef = useRef(false);
  const readyRef = useRef(false);
  const store = useStore();
  const { reducersManager, epicsManager, apiManager } = store;
  const {
    name,
    reducersMap = {},
    epics = [],
    middlewares = [],
    apiList = {},
    wsApiList = {}
  } = config || {};
  const configNotNull = (config == null ? void 0 : config.apiList) != null || (config == null ? void 0 : config.wsApiList) != null || (config == null ? void 0 : config.reducersMap) != null || (config == null ? void 0 : config.epics) != null || (config == null ? void 0 : config.middlewares) != null;
  const moduleLoaded = useSelector((state) => selectModuleLoaded(state, name));
  useEffect(() => {
    if (moduleLoaded) {
      setReadyToRenderState(moduleLoaded);
      readyRef.current = true;
      dispatchCalledRef.current = true;
    }
  }, [moduleLoaded]);
  useEffect(() => {
    if (!reducersManager || !epicsManager || !apiManager)
      return;
    new Promise((resolve) => {
      let ready = false;
      if (readyRef.current) {
        resolve(ready);
        return;
      }
      for (const key in apiList) {
        apiManager.addApi(key, apiList[key], store);
      }
      for (const key in wsApiList) {
        apiManager.addWsApi(key, wsApiList[key]);
      }
      const keys = Object.keys(reducersMap);
      keys.forEach((key, i) => {
        reducersManager.add(key, reducersMap[key]);
        ready = configNotNull && i === keys.length - 1;
      });
      epicsManager.add(epics);
      addMiddleware(middlewares);
      resolve(ready);
    }).then((value) => {
      if (!value) return;
      setReadyToRenderState(true);
      if (dispatchCalledRef.current) return;
      dispatch(setModuleLoaded(name));
    });
    return () => {
      if (!reducersManager || !epicsManager || !apiManager || disableAutoClear)
        return;
      middlewares.forEach((middleware) => {
        removeMiddleware(middleware);
      });
      for (const key in reducersMap) {
        reducersManager.remove(key);
      }
      for (const key in apiList) {
        apiManager.removeApi(key);
      }
      for (const key in wsApiList) {
        apiManager.removeApi(key);
      }
      dispatch(removeModuleLoaded(name));
      dispatchCalledRef.current = false;
      readyRef.current = false;
    };
  }, [configNotNull]);
  return readyToRender;
};
export {
  useModuleManager
};
